import React from "react";
import SelfSchemaExplorer from "../components/SelfSchemaExplorer";

export default function SelfSchemaTool() {
  return (
  <div className="page">
    <SelfSchemaExplorer />
  </div>
  );
}





